import Vue from "vue";
import HttpFactory from '@/mixins/http.factory';
export default Vue.extend({
    mixins:[HttpFactory],
    data() {
        return {
            dateTxt:null
        }
    },
    created(){
        let _self=this;
        _self.dateTxt=_self.params.value;
    },
});